<template>
  <Dialog
    v-model:visible="visibleLocal"
    @hide="$emit('close')"
    modal
    header="Инструкция по скачиванию"
    :style="{ width: '50vw' }"
  >
    <div>
      Вы можете скачать каждую таблицу или график дашборда по отдельности. Для
      этого в правом верхнем углу таблицы кликните на иконку "...", затем
      выберите "Сохранить как" -> XLSX. Пример представлен на рисунке ниже.
    </div>
    <div class="img-container">
      <img
        src="@/assets/images/instuction_dashes.jpg"
        alt="instruction"
        width="600px"
      />
    </div>

    <div class="flex buttons">
      <Button
        type="button"
        label="Закрыть"
        severity="secondary"
        @click="$emit('close')"
      ></Button>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

const props = defineProps<{
  visible: boolean;
}>();

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);
</script>

<style lang="scss" scoped>
.p-button.danger {
  background: $danger-color;
  border: 1px solid $danger-color;
}

.buttons {
  margin-top: 20px;
  justify-content: flex-end;
  button {
    &:first-child {
      margin-right: 20px;
    }
  }
}

.img-container {
  margin-top: 20px;
  text-align: center;

  img {
    max-width: calc(100% - 40px);
  }
}
</style>
